import { render, staticRenderFns } from "./ApprovalDetails.vue?vue&type=template&id=06967eb8&scoped=true&"
import script from "./ApprovalDetails.vue?vue&type=script&lang=js&"
export * from "./ApprovalDetails.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalDetails.vue?vue&type=style&index=0&id=06967eb8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06967eb8",
  null
  
)

export default component.exports